<template>
    <div class="conteudo">
		<!-- CABEÇALHO -->
        <flCabecalhoForm :msg="_traducao('global','obrigatorio')" cls="print-titulo-form-20" :texto="'Endereço Residencial'" />
		<!-- ENDEREÇO RESIDENCIAL -->
        <fl-endereco tipo="residencial" ref="endereco_residencial" @dados-endereco-residencial="(item) => { form.dados_endereco_residencial = item }" />

		<!-- CABEÇALHO -->
        <flCabecalhoForm :msg="_traducao('global','obrigatorio')" cls="print-titulo-form-20" :texto="'Endereço Funcional'" />
		<!-- CEP/LOGRADOURO/NUMERO/COMPLEMENTO/BAIRRO/CIDADE/ESTADO -->
        <fl-endereco tipo="funcional" ref="endereco_funcional" @dados-endereco-funcional="(item) => { form.dados_endereco_funcional = item }" />

		<!-- INFORMAÇÕES VINDA DO COMPONENTE DADOS-ADICIONAIS -->
		<!-- CEP/LOGRADOURO/NUMERO/COMPLEMENTO/BAIRRO/CIDADE/ESTADO -->
        <fl-dados-adicionais ref="dados_adicionais"
                            @dados-adicionais="(obj) => {
                                form.dados_adicionais = obj.form,
                                form.dados_emergencia = obj.dados,
                                form.dados_contato_emergencial = obj.contato,
                                form.dados_endereco_emergencial = obj.endereco,
                                form.tipo = obj.tipo
                            }" :postos="postos" :cargos="cargos" :menu="menu"/>

    </div>
</template>
<script>
import flDadosAdicionais from './dados-adicionais.vue'
import flEndereco from '../../../../../components/endereco/main.vue'

export default {
    props: ['menu', 'postos', 'cargos'],
    components: {
        flDadosAdicionais,
        flEndereco,
    },
    data () {
        return {
            form: {
                dados_endereco_residencial: {},
                dados_endereco_funcional: {},

                dados_endereco_emergencial: {
                    bairro: '',
                    cep: '',
                    cidade: '',
                    complemento: '',
                    estado: '',
                    logradouro: '',
                    numero: '',
                },

                dados_emergencia: {
                    alergia: '',
                    fator_rh: '',
                    tipo_sanguineo: '',
                },

                dados_adicionais: {
                    cargo: '',
                    data_nascimento: '',
                    masp: '',
                    nome_guerra: '',
                    id_posto_graduacao: '',
                },

                dados_contato_emergencial: {
                    celular_emergencia: '',
                    grau_emergencia: '',
                    nome_emergencia: '',
                    telefone_emergencia: '',
                },
                tipo: '',
            }
        }
    },
    methods: {
        editar (dados) {
            this.$nextTick(() => {
                this.$refs.endereco_residencial.editar({item: dados, tipo: 'residencial'})
            })

            this.$nextTick(() => {
                this.$refs.endereco_funcional.editar({item: dados, tipo: 'funcional'})
            })

            this.$nextTick(() => {
                this.$refs.dados_adicionais.editar(dados)
            })
        },

        validaForm () {
            let passou = true

            if(!this.$refs.endereco_residencial.validaForm()){
                passou = false
            }

            if(!this.$refs.endereco_funcional.validaForm()){
                passou = false
            }

            if(!this.$refs.dados_adicionais.validaForm()){
                passou = false
            }

            if(passou){
                this.$emit('dados-usuario', {form: this.form})
            }

            return passou
        }
    }
}
</script>